import * as React from "react"
import { VisibilityContext } from "react-horizontal-scrolling-menu"
import { CircleArrowIcon } from "../../common/icons/circle-arrow-icon"

export const RightArrow = ({ right = "10px" }) => {
  const { isLastItemVisible, scrollNext } = React.useContext(VisibilityContext)

  return (
    <CircleArrowIcon
      directionIcon="right"
      position="absolute"
      zIndex={100000}
      right={right ?? "10px"}
      bottom="31%"
      visibility={isLastItemVisible ? "hidden" : "visible"}
      disabled={isLastItemVisible}
      onClick={() => scrollNext()}
    />
  )
}
